export default {
  technicalIssue: 'Please try again, a technical issue occurred. If you continue to experience difficulties you can order by phone at 1-800-289-6229.',
  callCenterJewelryMessage: 'Have a question or need advice? Call one of our fine jewelry experts at <strong>1-800-BUY-MACY.</strong>',
};
